import {PartnersList,TabsList} from '../../../type';
import './style.less';
const Content = (props:TabsList) => {
    return (
        <div className="tab_content">
            <div className="content">
                <div className="content_title">
                    {props.title ?? ""}
                </div>
                <div className="content_ul">
                    {
                      
                        props?.TabsContent[0].contentList.partnersList?.map((value:PartnersList,index:number) => {
                            return (
                                <div className="ul_li" key={index}>
                                    <div className="li_title">
                                       {value.title ?? ""}
                                    </div>
                                    <div className="li_des">
                                        {value.content ?? ""}
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
           <img className="tab_content_img" src={props.sideImg} alt="" />
        </div>
    )
}

export default Content;